import { styled } from "@mui/material/styles";

const StyledProfileMenu = styled('aside')`

  .title {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  .paper {
    border-radius: 10px;
    background-color: #fff;
    padding: 0.6rem;
  }

  .user-data {
    color: ${props => props.theme.customTheme.colors.dark};
    font-size: ${props => props.theme.customTheme.sizes.normal};
    line-height: 1.25rem;
    padding: 0.75rem 0.6rem;
    background-color: ${props => props.theme.customTheme.bg.snow};
    border-radius: 10px;
    margin-bottom: 0.6rem;
    
    strong {
      display: block;
      font-size: ${props => props.theme.customTheme.sizes.middle};
      font-weight: 600;
      line-height: 1.25rem;
      margin-bottom: 0.6rem;
    }
  }

  .profile-menu {
    &__list {
      list-style: none;
      margin: 0;
      padding: 0;

      display: flex;
      flex-direction: column;
      gap: 0.6rem;
    }

    &__item {
      cursor: pointer;
    }

    &__link {
      border-radius: 10px;
      padding: 0.6rem 0.5rem;
      font-size: ${props => props.theme.customTheme.sizes.normal};
      color: ${props => props.theme.customTheme.colors.dark200};
      transition: background-color 0.3s ease, color 0.3s ease;
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      &:hover {
        color: ${props => props.theme.customTheme.colors.dark};
        background-color: ${props => props.theme.customTheme.bg.lightPrimary};
      }

      svg {
        width: 24px;
        height: 24px;
      }
    }
    &__link.active-navlink {
      color: #fff;
      background-color: ${props => props.theme.customTheme.bg.primary};
    }
  }
`;

export {
  StyledProfileMenu,
};
